"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REVIEVE_USER_ID_COOKIE = exports.OPTANON_CONSENT_COOKIE = exports.OPEN_QUERY_PARAM_VALID_VALUES = exports.OPEN_QUERY_PARAM_ONCE = exports.OPEN_QUERY_PARAM_ALWAYS = exports.OPEN_QUERY_PARAM = exports.OPEN_HREF_ATTRIBUTE = exports.ONE_TRUST_GROUP_PERFORMANCE = void 0;
var _constantsGenerated = require("../constants-generated");
// istanbul ignore file

const OPEN_HREF_ATTRIBUTE = exports.OPEN_HREF_ATTRIBUTE = `#open-${_constantsGenerated.APP_NAME}`;
const OPEN_QUERY_PARAM = exports.OPEN_QUERY_PARAM = 'openNovageSkincareAdvisor';
const OPEN_QUERY_PARAM_ALWAYS = exports.OPEN_QUERY_PARAM_ALWAYS = 'always';
const OPEN_QUERY_PARAM_ONCE = exports.OPEN_QUERY_PARAM_ONCE = 'once';
const OPEN_QUERY_PARAM_VALID_VALUES = exports.OPEN_QUERY_PARAM_VALID_VALUES = [OPEN_QUERY_PARAM_ALWAYS, OPEN_QUERY_PARAM_ONCE];
const OPTANON_CONSENT_COOKIE = exports.OPTANON_CONSENT_COOKIE = 'OptanonConsent';
const ONE_TRUST_GROUP_PERFORMANCE = exports.ONE_TRUST_GROUP_PERFORMANCE = 'C0002';
const REVIEVE_USER_ID_COOKIE = exports.REVIEVE_USER_ID_COOKIE = 'revieve-userid';